import {
  GET_USER_DETAIL,
  GET_USER_DETAIL_ERROR,
  GET_USER_DETAIL_REQUEST,
  UPDATE_USER_DETAIL_DATA,
  REMOVE_USER_DETAIL_DATA,
  REMOVE_USER_NAME_DATA,
} from "../ActionTypes/ActionTypes.js";

const initialState = {
  userDetailLoading: false,
  userDetailData: null,
  userDetailError: null,
  userDetailStatus: null,
  userName: null,
  isModified: false,
  selectedTerminal: {},
  isFirstLoad: true,
};

const userDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_DETAIL_REQUEST:
      return {
        ...state,
        userDetailLoading: state.isFirstLoad,
        // userDetailStatus: null,
        // userName: null,
      };
    case GET_USER_DETAIL:
      return {
        userDetailLoading: false,
        userDetailData: action.payload,
        userDetailError: null,
        userDetailStatus: true,

        selectedTerminal: action.payload.result?.selectedTerminal || {},
        isFirstLoad: false,
        userName: action?.payload?.result?.firstName +
          action?.payload?.result?.lastName
        ,
      };

    case GET_USER_DETAIL_ERROR:
      return {
        userDetailLoading: false,
        userDetailData: null,
        userDetailError: action?.payload,
        userDetailStatus: action?.payload?.success,
        isFirstLoad: false,
      };
    case UPDATE_USER_DETAIL_DATA:
      return {
        ...state,
        userDetailData: {
          ...state.userDetailData,
          ...action.payload,
        },
      };
    case REMOVE_USER_DETAIL_DATA:
      return {
        ...state,
        userDetailData: null,
        userDetailError: null,
        isModified: false,
        userDetailStatus: null,
        isFirstLoad: true,
        userName: null,
      };
    case REMOVE_USER_NAME_DATA:
      return { ...state, userName: null };
    default:
      return state;
  }
};

export default userDetailReducer;
